export default {
  copyValues(source, target) {
    return source
      ? Object.assign(
          {},
          target,
          ...Object.keys(target).map(
            (key) => key in source && { [key]: source[key] }
          )
        )
      : {};
  },
};
